export default __webpack_public_path__ + "84fcb754643f2928865b3e1656b49b9a.svg";